module.exports = __webpack_public_path__ + "static/media/4@2x.a11141cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_148/img/4@2x.png
// module id = 1425
// module chunks = 0